exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".marketing .text{margin:3rem 1rem;min-width:350px;max-width:650px;padding:2rem}.marketing .text h2,.marketing .text p{text-align:center}@media(min-width: 768px){.marketing .text h2,.marketing .text p{text-align:left}}.marketing .quote-carousel{min-width:400px}.marketing .quote-carousel h2{text-align:center}.marketing .quote-carousel .carousel-wrapper{max-width:450px;margin:0 20%}.marketing .quote-carousel .carousel-wrapper .auto-carousel .quote-block{contain:content;max-width:450px;height:275px;margin-top:10px;margin-bottom:30px}@media(min-width: 576px){.marketing .quote-carousel .carousel-wrapper .auto-carousel .quote-block{margin-bottom:40px}}@media(min-width: 992px){.marketing .quote-carousel .carousel-wrapper .auto-carousel .quote-block{margin-bottom:-20px}}.marketing .quote-carousel .carousel-wrapper .auto-carousel .quote-block .open-quote{font:bold 72px Gill Sans;margin-bottom:-40px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Home/Marketing/Marketing.scss
// module id = 7479
// module chunks = 13